<!--
 * @Descripttion:
 * @Author: sch
 * @LastEditTime: 2022-05-24 15:35:19
-->
<template>
  <div>
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-refresh="onRefresh"
              @on-infinite="onInfinite"
              ref="my_scroller"
    >
      <div class="container">
        <div class="lt" ref="listItem1">
          <div class="p1" v-for="(itemL,index) in list1" :key="index">
            <div @click="goCommentDetails(itemL)">
              <img class="img_s" :src="itemL.path" >
              <img v-if="itemL.isvideo==1" style="position: absolute;right: 0.1rem;top: 0.1rem;
                          width: 0.28rem;height: 0.28rem;" src="/static/images/community/video.png">
            </div>
            <div class="txt_ms">{{itemL.content}}</div>
            <div class="bottom_icons">
              <div class="bt_lt"><img class="img_lf" :src="itemL.head">
                <span>{{itemL.smallname}}</span>
              </div>
              <div class="bt_rt">
                <img  class="img_rt" @click="handleClickZan(itemL,index,'lt')" :src="getzanStatus(itemL.islike)">
                <span>{{itemL.like_nums}}</span></div>
            </div>
          </div>
        </div>

        <div class="rt" ref="listItem2">
          <div class="p2" v-for="(itemR,index) in list2" :key="index">
            <div @click="goCommentDetails(itemR)">
              <img class="img_s" :src="itemR.path" >
              <img v-if="itemR.isvideo==1" style="position: absolute;right: 0.1rem;top: 0.1rem;
                          width: 0.28rem;height: 0.28rem;" src="/static/images/community/video.png">
            </div>
            <div class="txt_ms">{{itemR.content}}</div>
            <div class="bottom_icons">
              <div class="bt_lt"><img class="img_lf" :src="itemR.head">
                <span>{{itemR.smallname}}</span>
              </div>
              <div class="bt_rt">
                <img  class="img_rt" @click="handleClickZan(itemR,index,'rt')" :src="getzanStatus(itemR.islike)">
                <span>{{itemR.like_nums}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Scroller>
  </div>

</template>
<script>
  import { customRequestAjax } from "@/axiosApi";
  import { isWeixin } from "../../assets/common/js/config";
  import Scroller from "../common/Scroller";

  export default {
    components: {
      Scroller
    },
    data() {
      return {
        list1: [],
        list2: [],
        refresh: false,
        loading: false,
        finished: false,
        nowPage: 0,
        noDataText: "—— 客官，木有啦~ ——"
      };
    },
    methods: {
      onRefresh() {
        this.refresh = true;
        this.nowPage = 1;
        this.getList();
      },
      onInfinite() {
        this.loading = true;
        this.finished = false;
        this.nowPage++;
        this.getList();
      },

      getzanStatus(states) {
        let urls =
          states == 1
            ? "../../../static/images/buyersShow/zanSelect.png"
            : "../../../static/images/buyersShow/zandefault.png";
        return urls;
      },
      getList() {
        var url =
          "Wxmall/Comment/getItemshowList?itemid=" + this.$route.query.itemid
          +
          "&pageno=" +
          this.nowPage +
          "&pagesize=" +
          this.pagesize;
        customRequestAjax(url)
          .then(res => {
            if (res.data.code == 200) {
              console.log(this.nowPage, this.pagesize)
              if (this.nowPage == 1) {
                this.list1 = []
                this.list2 = []
                this.refresh = false
              }
              if (res.data.list.length < this.pagesize) {
                this.finished = true
                if (this.nowPage == 1 && !res.data.list.length) {
                  this.list1 = []
                  this.list2 = []
                }
              } else {
                this.finished = false
              }
              this.$nextTick(() => {
                setTimeout(() => {
                  this.doSort(0, res.data.list)
                })
              })
            }
          })
          .catch(err => {});
      },


      doSort (index, list) {
        let that = this
        if (index < list.length) {
          f()
          function f() {
            if (that.$refs.listItem1.clientHeight <= that.$refs.listItem2.clientHeight) {
              that.list1.push(list[index])
            } else {
              that.list2.push(list[index])
            }
            if (index < list.length - 1) {
              that.loading = true
            } else {
              that.loading = false
            }
            that.$nextTick(() => {
              setTimeout(() => {
                that.doSort(index + 1, list)
              }, 100)
            })
          }
        }
      },
      //点赞和取消
      handleClickZan(item, index, typeVal) {
        if (!isWeixin()) {
          if (
            this.waptoken.waptoken &&
            this.waptoken.waptoken == this.waptoken.tourists
          ) {
            this.$store.commit(
              "PATH_VALUE",
              JSON.stringify({ itemid: this.$route.query.itemid })
            );
            this.$router.push({
              path: "/login",
              query: {
                routeval: "productdetail"
              }
            });
          } else {
            f(item, index, typeVal);
          }
        } else {
          f(item, index, typeVal);
        }
        function f(item, index, typeVal) {
          let urls = "Wxmall/Comment/addCommentLike";
          let data = {
            id: item.id,
            type: item.islike == 0 ? 1 : 2,
            isofficia: item.isofficia
          };
          customRequestAjax
            .post(urls, data)
            .then(res => {
              if (res.data.code == 200) {
                if (item.islike == 1) {
                  item.islike = 0;
                  item.like_nums = parseInt(item.like_nums) - 1;
                  this.$toast("取消成功");
                } else {
                  item.islike = 1;
                  item.like_nums = parseInt(item.like_nums) + 1;
                  this.$toast("点赞成功");
                }
                if (typeVal == "lf") {
                  this.$set(this.dataLt, index, item);
                } else {
                  this.$set(this.dataRt, index, item);
                }
              }
            })
            .catch(err => {});
        }
      },

      goCommentDetails(item) {
        var query = this.$route.query
        query.goodcomment = 1
        query.commentid = item.id
        query.isofficia = item.isofficia
        this.$router.push({
          path: "/commentDetail",
          query: query
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .container {
    box-sizing: border-box;
    text-align: center;
    background: #f5f5f5;
    padding-top: 0.05rem;
    overflow: hidden;
    .lt {
      width: 50%;
      float: left;
      .p1 {
        background: #fffeff;
        margin: 0.04rem 0.02rem 0.08rem 0.04rem;
        border-radius: 0.04rem;
        padding-bottom: 0.01rem;
        position: relative;
        .img_s {
          width: 100%;
          // max-height: 320px;
          border-radius: 0.04rem 0.04rem 0 0;
          // background-size: 100% 100%;
          margin: 0 auto;
        }
        .txt_ms {
          font-size: 0.14rem;
          max-height: 0.36rem;
          margin: 0.1rem;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-align: left;
        }
        .bottom_icons {
          display: flex;
          flex-direction: row;
          margin: 0.1rem;
          .bt_lt {
            width: 70%;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            .img_lf {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 0.2rem;
            }
            span {
              font-size: 0.14rem;
              padding-left: 0.05rem;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
          }
          .bt_rt {
            width: 30%;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-end;
            .img_rt {
              width: 0.2rem;
              height: 0.2rem;
            }
            span {
              font-size: 0.12rem;
              padding-left: 0.05rem;
              color: #969696;
              line-height: 0.22rem;
            }
          }
        }
      }
    }

    .rt {
      width: 50%;
      float: left;
      .p2 {
        background: #fffeff;
        margin: 0.04rem 0.02rem 0.08rem 0.04rem;
        border-radius: 0.04rem;
        padding-bottom: 0.01rem;
        position: relative;
        .img_s {
          width: 100%;
          border-radius: 0.04rem 0.04rem 0 0;
          margin: 0 auto;
        }
        .txt_ms {
          font-size: 0.14rem;
          margin: 0.1rem;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-align: left;
        }
        .bottom_icons {
          display: flex;
          flex-direction: row;
          margin: 0.1rem;
          .bt_lt {
            width: 70%;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-start;
            .img_lf {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 0.2rem;
            }
            span {
              font-size: 0.14rem;
              padding-left: 0.5rem;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
            }
          }
          .bt_rt {
            width: 30%;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: flex-end;
            .img_rt {
              width:0.2rem;
              height: 0.2rem;
            }
            span {
              font-size: 0.12rem;
              padding-left: 0.05rem;
              color: #969696;
              line-height: 0.22rem;
            }
          }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/buyersShow/fansShow.vue